<template>
  <div class="login-page">
    <el-card>
      <center>
        <img :src="img" width="100%" class="logo" />
        <h4>Welcome Tenant</h4>
      </center>
      <el-form :model="form" label-width="240px" ref="loginForm" @submit.native.prevent="onSubmit">
        <el-form-item label="账号：" label-width="80px" :rules="{
          required: true,
          message: '请输入账号',
        }">
          <el-input v-model="form.account"></el-input>
        </el-form-item>
        <el-form-item label="密码：" label-width="80px" :rules="{
          required: true,
          message: '请输入密码',
        }">
          <el-input type="password" v-model="form.password"> </el-input>
        </el-form-item>
        <!-- <el-form-item
          class="phone-code-form-item"
          label="手机验证码："
          prop="code"
          :rules="{
            required: true,
            message: '请输入手机验证码',
          }"
        >
          <el-input v-model="form.code"></el-input>
          <el-button
            @click.prevent="handlePhoneCode"
            :disabled="!form.account || !enableSendPhoneCode"
          >
            <span v-if="!enableSendPhoneCode">{{ this.timeDelay }}s</span>
            <span v-if="enableSendPhoneCode">获取验证码</span>
          </el-button>
        </el-form-item> -->
        <!-- <el-form-item
          class="phone-code-form-item"
          label="谷歌验证码："
          label-width="110px"
          prop="gCode"
          :rules="{
            required: true,
            message: '请输入谷歌验证码',
          }"
        >
          <el-input v-model="form.gCode" @focus="focus($event)"></el-input>
         
        </el-form-item> -->

        <el-form-item class="actions">
          <el-button type="primary" native-type="submit" class="login-btn">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog :title="isShow ? '输入谷歌验证码' : '扫描下方二维码绑定谷歌验证'" :visible.sync="secondStepDialog" width="300px"
      :before-close="handleClose">
      <div style="margin-left: 70px" :class="{ box: isShow }">
        <img :src="qrCode" width="128px" height="128px" />
      </div>
      <div class="gCode">
        <el-form>
          <el-form-item label="验证码：" label-width="80px" :rules="[
            {
              required: true,
              message: '请输入验证码',
            },
          ]">
            <el-input v-model="form.googleCode"></el-input>
          </el-form-item>
          <!-- <el-form-item label="验证码：">
        <el-input type="text" v-model="gCode"></el-input>
        </el-form-item> -->
        </el-form>
        <!-- <span class="textTip">输入验证码：</span>
        <el-input type="text" v-model="gCode"></el-input> -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancle">取 消</el-button>
        <el-button size="mini" type="primary" @click="secondLogin">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import logo from "../src/assets/logo@2x.png";
import encrypt from "@/utils/encrypt";
import { firstAccessibleMenuPath } from "common/permission";
export default {
  name: "LoginPage",
  data() {
    return {
      img: logo,
      gCode: "",
      form: {
        googleCode: "",
      },
      timeDelay: 60,
      enableSendPhoneCode: true,
      secondStepDialog: false,
      isShow: true,
      qrCode: "",
      uuid: "",
    };
  },
  methods: {
    ...mapActions([
      "login",
      "getPhoneCode",
      "secondSuffix",
      "getUserInfo",
      "logout",
    ]),

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.form.googleCode = "";
          done();
          this.secondStepDialog = false;
        })
        .catch((_) => { });
    },
    cancle() {
      this.secondStepDialog = false;
      this.form.googleCode = "";
    },
    secondLogin() {
      this.secondSuffix({ ...this.form, uuid: this.uuid }).then((res) => {
        if (res.code == 0) {
          this.getUserInfo().then((userRes) => {
            if (userRes.code == 0) {
              const defaultPath = firstAccessibleMenuPath(
                (userRes.data && userRes.data.menuTree) || []
              );
              this.$router.replace({ path: defaultPath || "/" }).catch((err) => {
                // Vue Router 3 会将守卫重定向/重复导航作为 rejected Promise；
                // 目标路由已经完成时无需再向控制台抛出未捕获异常。
                if (this.$route.path !== (defaultPath || "/")) throw err;
              });
              return;
            }
            this.$message.error("获取用户权限失败");
            this.logout();
          });
        }
      });
    },
    onSubmit() {
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          this.login({
            account: this.form.account,
            password: encrypt(this.form.password),
          }).then((res) => {
            if (res.code == 0) {
              this.secondStepDialog = true;
              const {
                data: { qrCode, uuid },
              } = res;
              qrCode
                ? ((this.isShow = false), (this.qrCode = res.data.qrCode))
                : (this.isShow = true);
              this.uuid = uuid;
              // this.$router.push({ path: "/home" });
            }
          });
        }
      });
    },
    handlePhoneCode() {
      this.getPhoneCode(this.form.account).then(() => {
        this.$message.success("验证码已发送，请注意查收。");
        this.enableSendPhoneCode = false;
        this.timeInterval();
      });
    },
    timeInterval() {
      const interval = setInterval(() => {
        this.timeDelay--;
        if (this.timeDelay === 0) {
          this.enableSendPhoneCode = true;
          this.timeDelay = 60;
          clearInterval(interval);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.logo {
  width: 160px;
  height: 80px;
}

.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #edf2f8;
}

.login-page .el-card {
  padding: 20px;
  min-width: 450px;
}

.actions {
  margin-bottom: 0;
}

.actions /deep/ .el-form-item__content {
  margin-left: 0 !important;
}

.login-btn {
  width: 100%;
  font-size: 16px;
}

.forget-link {
  font-size: 14px;
  float: right;
}

.phone-code-form-item {
  /deep/ .el-form-item__content {
    display: flex;
    align-items: flex-start;

    .el-input {
      .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    .el-button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: 0;
      width: 115px;
    }
  }
}

/deep/.el-dialog__title {
  font-size: 12px;
}

.gCode {
  height: 30px;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .textTip {
    width: 100px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
}

.box {
  display: none;
}
</style>
